export type Deferred<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

/**
 * `Promise.withResolvers` without the platform requirement.
 *
 * The native method only landed in Chrome 119 / Firefox 121 / Safari 17.4 and
 * Node 22, but this project's browserslist reaches further back and CI runs on
 * Node 20. Multicall sits behind every on-chain read, so calling the native
 * method directly there is a hard failure on those targets rather than a
 * graceful degradation.
 */
export function withResolvers<T>(): Deferred<T> {
  let resolve!: (value: T | PromiseLike<T>) => void;
  let reject!: (reason?: unknown) => void;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve, reject };
}
